import { WIDGET_SIZES, WIDGET_TYPES } from 'components/global/ManageWidgetsModal';

export const dashboardChartsConfigRaw = {
	'/dashboard_new': [
		{
			id: 'numberOfOrders',
			type: WIDGET_TYPES.cards,
			size: WIDGET_SIZES.large,
			infoMessage: 'dashboard.numberOfOrders.infoMessage'
		},
		{
			id: 'overview',
			type: WIDGET_TYPES.cards,
			size: WIDGET_SIZES.large
		},
		{
			id: 'currentOrders',
			type: WIDGET_TYPES.pie,
			size: WIDGET_SIZES.large
		},
		{
			id: 'closedAndProcessingOrders',
			type: WIDGET_TYPES.pie,
			size: WIDGET_SIZES.large
		},
		{
			id: 'dashboard.orderDistribution',
			type: WIDGET_TYPES.column,
			size: WIDGET_SIZES.large
		}
	]
};
